import SVGDirection from "components/_common/icons/vdm/SVGDirection";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import { Dispatch } from "redux";
import { IStore } from "redux/store";

interface IStatusRanges {
	veryLow: [number, number];
	inRange: [number, number];
	veryHigh: [number, number];
}

const getStatus = (val: number, statusRanges: IStatusRanges) => {
	const { veryHigh, inRange, veryLow } = statusRanges;
	if (val <= veryHigh[1] && val > veryHigh[0]) {
		return { status: "Very High", statusColor: "#ff7c7c" };
	} else if (val <= inRange[1] && val >= inRange[0]) {
		return { status: "In Range", statusColor: "#101828" };
	} else if (val < veryLow[1] && val >= veryLow[0]) {
		return { status: "Very Low", statusColor: "#ff7c7c" };
	} else {
		return { status: "In Range", statusColor: "#101828" };
	}
};

type OwnProps = {
	title: string;
	range: [number, number];
	value: number;
	statusRanges: IStatusRanges;
	fillColor?: string;
};
type MetricGaugeProps = PropsFromRedux & OwnProps;
function MetricGauge(props: MetricGaugeProps) {
	const { title, range, value, statusRanges, fillColor = "#ff7c7c" } = props;
	const [minValue, maxValue] = range;
	const currentValue = Math.min(value, maxValue);
	const rotationAngle = (currentValue / maxValue) * 180 - 90;

	const data = [
		{ name: "filled", value: currentValue },
		{ name: "empty", value: maxValue - currentValue },
	];

	const { status, statusColor } = getStatus(currentValue, statusRanges);

	return (
		<div>
			<h3 className="text-sm font-medium text-gray-700 mb-4 text-center">
				{title}
			</h3>

			{/* Gauge Container */}
			<div className="relative mb-4 h-24 w-36">
				<ResponsiveContainer width="100%" height="100%">
					<PieChart>
						<Pie
							data={data}
							cx="50%"
							cy="90%"
							startAngle={180}
							endAngle={0}
							innerRadius={45}
							outerRadius={68}
							dataKey="value"
							strokeWidth={1}
							stroke="#e4e7e9"
						>
							<Cell fill={fillColor} />
							<Cell fill="transparent" />
						</Pie>
					</PieChart>
				</ResponsiveContainer>

				{/* Scale markers */}
				<div className="absolute inset-0">
					<div className="absolute -bottom-3 left-5 text-xs text-gray-600">
						{minValue}
					</div>
					<div className="absolute -bottom-3 right-5 text-xs text-gray-600">
						{maxValue}
					</div>
					<div className="absolute bottom-0 left-1/2 -translate-x-1/2">
						<div
							className="transition-transform duration-500 ease-out"
							style={{
								transform: `rotate(${rotationAngle}deg)`,

								transformOrigin: "12px 19.5px",
							}}
						>
							<SVGDirection className="w-6 h-8" />
						</div>
					</div>
				</div>
			</div>
			<div className="text-center">
				<div
					style={{ color: statusColor }}
					className="text-sm font-medium mb-1"
				>
					{status}
				</div>
				<div style={{ color: statusColor }} className="text-xl font-medium">
					{value.toFixed(1)}
				</div>
			</div>
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(MetricGauge);
